import React from "react";
import { Stack } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { useGetAllVendorData } from "../../hooks";
import VendorsStatusChip from "./VendorsStatusChip";
import { useNavigate } from "react-router-dom";

const sortable = true;
const items = [
  {
    id: "name",
    label: "Name",
    sortable,
  },
  {
    id: "locationId",
    label: "Location",
    sortable,
  },
  {
    id: "status",
    label: "Status",
    sortable,
  },
];

const keys = [
  {
    value: "name",
  },
  {
    value: "location",
    isChip: true,
  },
  {
    value: "status",
    CustomComponent: VendorsStatusChip,
  },
];

export const VendorsTable = ({ defaultLocation = 1 }) => {
  const { data, isLoading } = useGetAllVendorData({ defaultLocation });

  const navigate = useNavigate();
  const handleRowClick = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/customers/${item.id}`);
  };

  const headerProps = { items };
  const bodyProps = { items: data?.rows, keys, onRowClick: handleRowClick };
  const props = { headerProps, bodyProps, meta: data?.meta, isLoading };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="VendorTable" {...props} />
    </Stack>
  );
};

export default VendorsTable;
